module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column px-4 py-4"
  }, [(_vm.result.message) ? _c('div', {
    staticClass: "errorText"
  }, [_vm._v(_vm._s(_vm.result.message))]) : _vm._e(), (_vm.result.attempt_number) ? _c('div', {
    staticClass: "data d-flex flex-column"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Номер попытки")]), _vm._v(_vm._s(_vm.result.attempt_number))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Сумма всех полученных баллов")]), _vm._v(_vm._s(_vm.result.sum_weight))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Всего количество попыток за тест")]), _vm._v(_vm._s(_vm.result.count_attempt))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Потрачено попыток")]), _vm._v(_vm._s(_vm.result.final_count_attempt))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Полученные баллы")]), _vm._v(_vm._s(_vm.result.points_received))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', {
    staticClass: "me-2"
  }, [_vm._v("Оценка")]), _vm._v(_vm._s(_vm.result.evaluation))])]) : _vm._e(), _c('AppButtonNew', {
    staticClass: "me-auto mt-4",
    on: {
      "click": function($event) {
        return _vm.$ui.$modal.close("ResultTestModalBody")
      }
    }
  }, [_vm._v("К списку тестов")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b9dc91","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/resultTestModalBody/ResultTestModalBody.vue
// module id = a22fb611610c976b72c4
// module chunks = 3